import { render } from "./CityUpdate.vue?vue&type=template&id=05fef075&scoped=true&ts=true"
import script from "./CityUpdate.vue?vue&type=script&lang=ts"
export * from "./CityUpdate.vue?vue&type=script&lang=ts"

import "./CityUpdate.vue?vue&type=style&index=0&id=05fef075&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fef075"]])

export default __exports__